import { render, staticRenderFns } from "./DangerQstDtlPop.vue?vue&type=template&id=cafe24b4"
import script from "./DangerQstDtlPop.vue?vue&type=script&lang=js"
export * from "./DangerQstDtlPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cafe24b4')) {
      api.createRecord('cafe24b4', component.options)
    } else {
      api.reload('cafe24b4', component.options)
    }
    module.hot.accept("./DangerQstDtlPop.vue?vue&type=template&id=cafe24b4", function () {
      api.rerender('cafe24b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/DangerQstDtlPop.vue"
export default component.exports